/*
* Internal Reserve Study form
*/

import { Upload } from '@progress/kendo-react-upload';
import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Modal, Row, Well } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import * as Treebeard from 'react-treebeard';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import { AssociationDetailsCopyAddress } from '../association/components/association-details-copy-address';
import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import { InventoryDetailFormComponentDetailsAssociation } from '../inventory/detail-form/component-details-association';
import { DefaultPictureNotFoundUrl } from '../inventory/detail-form/component-details-pictures';
import InventoryPhotoGallery from '../inventory/gallery';
import * as ReduxQueries from '../queries';
import * as ReportCharts from '../report/charts';
import * as ReportLogic from '../report/logic';
import * as ReportComponents from '../report/pdf/report-components';
import * as ReportCommon from '../report/report-common';
import * as RSF from './reservestudyform';

export const TreeBeardStyle = {
    tree: {
        component: {
            width: '50%',
            display: 'inline-block',
            verticalAlign: 'top',
            padding: '20px',
            '@media (max-width: 640px)': {
                width: '100%',
                display: 'block'
            }
        },

        base: {
            listStyle: 'none',
            // backgroundColor: '#21252B',
            margin: 0,
            padding: 0,
            // color: '#9DA5AB',
            // fontFamily: 'lucida grande ,tahoma,verdana,arial,sans-serif',
            fontSize: '14px'
        },

        node: {
            base: {
                position: 'relative'
            },

            link: {
                cursor: 'pointer',
                position: 'relative',
                padding: '0px 5px',
                display: 'block',
                color: '#263238',
            },

            activeLink: {
                color: '#2cabe3',
            },

            toggle: {
                base: {
                    position: 'relative',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    marginLeft: '-5px',
                    height: '24px',
                    width: '24px'
                },

                wrapper: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    margin: '-7px 0 0 -7px',
                    height: '14px'
                },

                height: 14,
                width: 14,
                arrow: {
                    // fill: '#9DA5AB',
                    fill: '#263238',
                    strokeWidth: 0
                }
            },

            header: {
                base: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                },

                connector: {
                    width: '2px',
                    height: '12px',
                    borderLeft: 'solid 2px black',
                    borderBottom: 'solid 2px black',
                    position: 'absolute',
                    top: '0px',
                    left: '-21px'
                },

                title: {
                    lineHeight: '24px',
                    verticalAlign: 'middle',
                    color: '#54667a',
                },

                titleActive: {
                    lineHeight: '24px',
                    verticalAlign: 'middle',
                    color: '#2cabe3',
                    fontWeight: '700',
                }
            },

            subtree: {
                listStyle: 'none',
                paddingLeft: '19px'
            },

            loading: {
                color: '#E2C089'
            }
        }
    }
};

export interface IReserveStudyProps extends AppComp.IAppComponentProps {
    association?: any;
    associationId?: any;
    archivedCharts?: any;
    updateReserveStudyChart?: any;
    currentOrder?: any;
    currentOrderChart?: any;
    inventory?: any;
    orders?: any;
    navigateTo?: any;
    forceRequest?: any;
    associationPhotos?: any;
    associationPhotoFolders?: any;
    associationPhotosTree?: any;
}

export interface IReserveStudyState extends AppComp.IAppComponentState {
    formChanges?: any;
    formChangesReset?: boolean;
    oneTimeSet: boolean;
    overrideUpdates?: any;
    showModalSaveChanges: boolean;
    showModalSelectCoverPicture: boolean;
    showModalSpecialAssessmentsWorksheet: boolean;
    showModalSpecialAssessmentsWorksheetCustomer: boolean;
    showModalSelectPictureFolder: string;
    // specialAssessments: Array<any>;
    modalSelectPictureFiles?: Array<any>;
}

export const ReserveStudyFormSection = ({ title, className = '', ...rest }) => {
    return (
        <div className={`reserve-study-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

class ReserveStudy extends AppComp.AppComponent<IReserveStudyProps, IReserveStudyState> {
    public originalFormDataCache = {};

    public constructor(props: IReserveStudyProps) {
        super(props, 'app.reserve-study.');

        this.state = {
            formChanges: {
                specialAssessments: [],
                specialAssessmentsCustomer: []
            },
            formChangesReset: false,
            overrideUpdates: {},
            oneTimeSet: false,
            showModalSaveChanges: false,
            showModalSelectCoverPicture: false,
            showModalSpecialAssessmentsWorksheet: false,
            showModalSpecialAssessmentsWorksheetCustomer: false,
            showModalSelectPictureFolder: '',
            // specialAssessments: [],
            modalSelectPictureFiles: undefined,
        };

        ReportCharts.setHighchartOptions();
    }

    public componentDidUpdate() {
        const {
            currentOrderChart,
        } = this.props;
        if (_.isUndefined(currentOrderChart)) {
            return;
        } else if (!this.state.oneTimeSet) {
            let worksheets = this.getWorksheets(currentOrderChart);
            if (_.isUndefined(worksheets)) {
                return;
            } else if (_.isUndefined(worksheets.regular) || _.isUndefined(worksheets.customer)) {
                return;
            }
            if (_.size(worksheets.regular[0]) > 0) {
                this.setState({ showModalSpecialAssessmentsWorksheet: true });
            }
            if (_.size(worksheets.customer[0]) > 0) {
                this.setState({ showModalSpecialAssessmentsWorksheetCustomer: true });
            }
            this.setState({ oneTimeSet: true });
        }
    }

    // Data transforms
    public extendAssociationData(record: any) {
        if (!record) { return; }
        let result = _.cloneDeep(record);
        return result;
    }

    public extendInventoryData(inventory: Array<any>, inventoryChanges: Array<any>, association: any) {
        // Extend grid row data
        if (!AppUtilities.isArrayWithLength(inventory)) { return []; }

        const extended = inventory.map((r, i) => {
            let record = _.cloneDeep(r);

            record.avgCost = ReportLogic.calculateInventoryItemAvgCost(record);
            record.avgCost_sort = Number(record.avgCost);
            if (!record.avgCost) {
                record.usefulLife = 'N/A';
                record.remainingUsefulLife = 0;
            }

            const invSubgroups = AppUtilities.getArray(association, 'inventorySubgroups');
            record.Group = '';
            if (AppUtilities.isArrayWithLength(invSubgroups)) {
                let subgroupDef: any = _.find(invSubgroups, ['groupCode', _.get(record, 'subgroup', '')]);
                if (subgroupDef && subgroupDef.title) { record.Group = subgroupDef.title; }
            }

            record.usefulLife_sort = (AppUtilities.isNumeric(record.usefulLife)) ? Formatters.int(record.usefulLife) : 0;
            record.remainingUsefulLife_sort = (AppUtilities.isNumeric(record.remainingUsefulLife)) ? Formatters.int(record.remainingUsefulLife) : 0;

            record.included = _.get(record, 'included', (record.avgCost_sort !== 0 && record.usefulLife !== 'N/A') ? true : false) as boolean;
            record.hypAvgCost = Formatters.float(_.get(record, 'hypAvgCost', record.avgCost_sort), 2);
            record.hypUsefulLife = Formatters.int(_.get(record, 'hypUsefulLife', record.usefulLife_sort));
            record.hypRemainingUsefulLife = Formatters.int(_.get(record, 'hypRemainingUsefulLife', record.remainingUsefulLife_sort));

            let invChanges = _.find(inventoryChanges, { inventoryId: record.inventoryId });
            if (invChanges) {
                record = _.merge(record, _.omit(invChanges, 'inventoryId'));
            }

            record.editing = record.included;

            return record;
        });

        return extended;
    }

    // Handlers
    public navigateToReportPdf() {
        this.props.navigateTo(NavigationLinks.associationReportPdf(_.get(this.props, 'associationId', 0)));
    }

    public handleOverrideButton(e: any) {
        this.navigateToReportPdf();
    }

    public handleEditOrderButton(e: any, orderId: number) {
        if (!orderId) { return; }

        this.props.navigateTo(NavigationLinks.orderEdit(orderId));
    }

    public handleReserveStudyPdfButton(e: any) {
        const fcCount = this.getFormChangesCount();
        if (fcCount > 0) { // 20200319 _.size(this.state.formChanges) > 0) {
            this.setState({ showModalSaveChanges: true, showModalSelectCoverPicture: false });
        } else {
            this.navigateToReportPdf();
        }
    }

    public handleViewPortalButton(e: any) {
        const fcCount = this.getFormChangesCount();
        if (fcCount > 0) { // 20200319 _.size(this.state.formChanges) > 0) {
            // if (_.size(this.state.formChanges) > 0) {
            this.setState({ showModalSaveChanges: true, showModalSelectCoverPicture: false });
        } else {
            this.props.navigateTo(NavigationLinks.portalAssociationReport(_.get(this.props, 'associationId', 0)));
        }
    }

    public handleViewAssociationButton(e: any) {
        const fcCount = this.getFormChangesCount();
        if (fcCount > 0) { // 20200319 _.size(this.state.formChanges) > 0) {
            // if (_.size(this.state.formChanges) > 0) {
            this.setState({ showModalSaveChanges: true, showModalSelectCoverPicture: false });
        } else {
            this.props.navigateTo(NavigationLinks.associationDetail(_.get(this.props, 'associationId', 0)));
        }
    }

    public handleViewInventoryButton(e: any) {
        const fcCount = this.getFormChangesCount();
        if (fcCount > 0) { // 20200319 _.size(this.state.formChanges) > 0) {
            // if (_.size(this.state.formChanges) > 0) {
            this.setState({ showModalSaveChanges: true, showModalSelectCoverPicture: false });
        } else {
            this.props.navigateTo(NavigationLinks.associationInventory(_.get(this.props, 'associationId', 0)));
        }
    }

    public handleViewFundingDisclosureClick(e: any) {
        const fcCount = this.getFormChangesCount();
        if (fcCount > 0) { // 20200319 _.size(this.state.formChanges) > 0) {
            // if (_.size(this.state.formChanges) > 0) {
            this.setState({ showModalSaveChanges: true, showModalSelectCoverPicture: false });
        } else {
            this.props.navigateTo(NavigationLinks.associationCaliforniaDisclosureReportPdf(_.get(this.props, 'associationId', 0)));
        }
    }

    public handleSelectCoverPictureButton(e: any) {
        let nextShowModalSelectCoverPicture: boolean = true;

        this.setState({ showModalSelectCoverPicture: nextShowModalSelectCoverPicture });
    }

    public handleShowSpecialAssessmentsWorksheetModal(e: any) {
        const nextShowModalSpecialAssessmentsWorksheet: boolean = true;

        this.setState({ showModalSpecialAssessmentsWorksheet: nextShowModalSpecialAssessmentsWorksheet });
    }

    public handleShowSpecialAssessmentsWorksheetCustomerModal(e: any) {
        const nextShowModalSpecialAssessmentsWorksheetCustomer: boolean = true;

        this.setState({ showModalSpecialAssessmentsWorksheetCustomer: nextShowModalSpecialAssessmentsWorksheetCustomer });
    }

    public handleCloseSpecialAssessmentsWorksheetModal(e: any) {
        const nextShowModalSpecialAssessmentsWorksheet: boolean = false;

        this.setState({ showModalSpecialAssessmentsWorksheet: nextShowModalSpecialAssessmentsWorksheet });
    }

    public handleCloseSpecialAssessmentsWorksheetCustomerModal(e: any) {
        const nextShowModalSpecialAssessmentsWorksheetCustomer: boolean = false;

        this.setState({ showModalSpecialAssessmentsWorksheetCustomer: nextShowModalSpecialAssessmentsWorksheetCustomer });
    }

    public handleSaveButton(e: any, viewPdfAfterSave: boolean = false) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const {
            associationPhotos,
            associationPhotoFolders,
            associationPhotosTree,
        } = this.props;

        const { associationId, association, currentOrder, currentOrderChart } = this.props;
        const assoc = this.extendAssociationData(association);
        const formData = this.getFormData(assoc, currentOrder, currentOrderChart, associationPhotos, associationPhotoFolders, associationPhotosTree);

        const changeData = _.merge(
            {},
            { currentOrder: _.pick(this.props.currentOrder, ['orderId', '_id']) },
            { formData: formData },
            { cppOverride: formData.cppOverride === 'reset' ? '' : formData.cppOverride },
            { rfOverride: formData.rfOverride === 'reset' ? '' : formData.rfOverride },
            { srpOverride: formData.srpOverride === 'reset' ? '' : formData.srpOverride },
            this.state.formChanges
        );

        if (!this.props.currentOrder.versionId && !formData.versionId) {
            alert('Version Number must be set before saving!');
            return;
        }

        if (!this.props.currentOrder.beginYear && (!formData.beginYear ||
            formData.beginYear === '0' ||
            formData.beginYear === 0 ||
            formData.beginYear === '' ||
            formData.beginYear === ' ' ||
            formData.beginYear === null ||
            formData.beginYear === undefined)
        ) {
            alert('Beginning Year must be set before saving! \n(Watch out for non-FYE jobs!)');
            return;
        }
        // console.log('passing changeData', changeData);

        this.props.updateReserveStudyChart(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // history.push(NavigationLinks.associationDetail(response.body.associationId));
                // FORCE RELOAD
                if (viewPdfAfterSave) {
                    this.navigateToReportPdf();
                } else {
                    this.originalFormDataCache = {};
                    this.setState(s => ({ formChanges: { specialAssessments: [], specialAssessmentsCustomer: [] }, showModalSaveChanges: false }));
                }
            } else {
                // Error during creation...
            }
        });
    }

    public handleFormInputChange(e: any, x: any) {
        const startFormChange = new Date().getTime();

        let fieldName = '';
        let newValue;

        if (_.get(e, 'target.props.name')) {
            // Kendo form element

            fieldName = _.get(e, 'target.props.name', '');
            newValue = _.get(e, 'value');
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                case 'number':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    break;
            }
        }

        if (!fieldName) { return; }

        let formChanges = _.cloneDeep(this.state.formChanges);
        // need to include formdata for special assessments so they don't get wiped updating a separate field.
        const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
        const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
        const ofdc = _.cloneDeep(this.originalFormDataCache);
        const fdsa = _.get(ofdc, 'specialAssessments', []);
        const fdsac = _.get(ofdc, 'specialAssessmentsCustomer', []);
        let merged = _.merge([], fdsa, fcsa);
        let mergedCustomer = _.merge([], fdsac, fcsac);
        _.set(formChanges, 'specialAssessments', merged);
        _.set(formChanges, 'specialAssessmentsCustomer', mergedCustomer);
        // console.log(`handleFormInputChange: fieldName ${fieldName} newValue ${newValue} e:`, e);

        let applyChange = false;
        let origVal = _.get(this.originalFormDataCache, fieldName);

        if (String(newValue) !== String(origVal)) {
            // New value
            _.set(formChanges, fieldName, newValue);
            applyChange = true;
        } else {
            // Same as orig val
            if (_.has(formChanges, fieldName)) {
                _.unset(formChanges, fieldName);
                applyChange = true;
            }
        }

        const startFormChangeSetState = new Date().getTime();
        if (applyChange) {
            // this.setState({ formChanges: formChanges });
            this.setState((prevState) => ({ formChanges: formChanges }), () => {
                const endFormChange = new Date().getTime();
                // console.log(`handleFormInputChange total time ${endFormChange - startFormChange}ms setState time ${endFormChange - startFormChangeSetState}ms`);
            });
        }
    }

    public handleShowArchivedChartData(orderId: number) {
        // TO-DO 
    }

    public handleFormSubmit(e: any) {
        // console.log('handleFormSubmit', e);
    }

    public handleShowModalSelectPictureButton(e: any, pictureFieldName: string = '') {
        // if (!pictureFieldName) { return; }
        this.setState({ showModalSelectCoverPicture: true }); // showModalSelectPictureForPictureField: pictureFieldName });
    }

    public handleHideModalSelectPictureButton(e: any) {
        this.setState({ showModalSelectCoverPicture: false }); // showModalSelectPictureForPictureField: '', showModalSelectPictureFolder: '' });
    }

    public handleCloseModalSpecialAssessmentsWorksheet() {
        this.setState({ showModalSpecialAssessmentsWorksheet: false });
    }

    public handleCloseModalSpecialAssessmentsWorksheetCustomer() {
        this.setState({ showModalSpecialAssessmentsWorksheetCustomer: false });
    }

    public handleSaveSpecialAssessmentsWorksheetButton(e: any) {
        this.setState({ showModalSpecialAssessmentsWorksheet: false });
    }

    public handleSaveSpecialAssessmentsWorksheetCustomerButton(e: any) {
        this.setState({ showModalSpecialAssessmentsWorksheetCustomer: false });
    }

    public handleTreeToggle(node: any, toggled: any) {
        this.setState({
            showModalSelectPictureFolder: Formatters.getStr(node, 'fullPath') || Formatters.getStr(node, 'name')
        });
    }

    public handleUploadBeforeUpload(e: any, spFullPath: any) {
        e.additionalData = {
            selectedPictureFolderFullPath: spFullPath,
        };

        this.setState({ modalSelectPictureFiles: e.newState });
    }

    public handleUploadAdd(e: any, spFullPath: any) {
        this.setState({ modalSelectPictureFiles: e.affectedFiles });
    }

    public handleUploadStatusChange(e: any, spFullPath: any) {
        // Reload data from api
        if (_.every(_.get(e, 'affectedFiles', []), ['status', 4])) {
            // all uploads suceeded, reload page
            this.props.forceRequest();
        } else {
            this.setState({ modalSelectPictureFiles: e.affectedFiles });
        }
    }

    public handleUploadBeforeRemove(e: any, spFullPath: any) {
        e.additionalData = {
            selectedPictureFolderFullPath: spFullPath,
        };
        this.setState({ modalSelectPictureFiles: e.newState });
    }

    public handleUploadRemove(e: any, spFullPath: any) {
        this.setState({ modalSelectPictureFiles: e.newState });
    }

    public handleUploadProgress(e: any, spFullPath: any) {
        this.setState({ modalSelectPictureFiles: e.newState });
    }

    public handleResetOverrides(e: any, name: string) {
        let formChanges = _.set(_.cloneDeep(this.state.formChanges), [name], '');
        const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
        const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
        const ofdc = _.cloneDeep(this.originalFormDataCache);
        const fdsa = _.get(ofdc, 'specialAssessments', []);
        const fdsac = _.get(ofdc, 'specialAssessmentsCustomer', []);
        let merged = _.merge([], fdsa, fcsa);
        let mergedCustomer = _.merge([], fdsac, fcsac);
        _.set(formChanges, 'specialAssessments', merged);
        _.set(formChanges, 'specialAssessmentsCustomer', mergedCustomer);
        let overrideUpdates = _.set(_.cloneDeep(this.state.overrideUpdates), [name], false);
        this.setState({ formChanges, overrideUpdates });
    }

    public handleOnChangeOverride(e: any) {
        const customReserveFunding = Formatters.getStr(e, 'target.value') ? Formatters.getStr(e, 'target.value') : '';
        let formChanges = _.cloneDeep(this.state.formChanges);
        const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
        const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
        const ofdc = _.cloneDeep(this.originalFormDataCache);
        const fdsa = _.get(ofdc, 'specialAssessments', []);
        const fdsac = _.get(ofdc, 'specialAssessmentsCustomer', []);
        let merged = _.merge([], fdsa, fcsa);
        let mergedCustomer = _.merge([], fdsac, fcsac);
        _.set(formChanges, 'specialAssessments', merged);
        _.set(formChanges, 'specialAssessmentsCustomer', mergedCustomer);
        _.set(formChanges, [e.target.name], customReserveFunding);
        let overrideUpdates = _.set(_.cloneDeep(this.state.overrideUpdates), [e.target.name], true);
        this.setState({ formChanges, overrideUpdates });
    }

    public closeModal() {
        this.setState({ showModalSaveChanges: false });
    }

    public showModal() {
        this.setState({ showModalSaveChanges: true });
    }

    // Helpers
    public getFormData(assoc: any, currentOrder: any, currentOrderChart: any, assocPhotos: any, assocPhotoFolders: any, assocPhotosTree: any, orders?: any, archivedCharts?: any) {
        let result = ReportCommon.GetFormData(assoc, currentOrder, currentOrderChart);

        let resPhotos = {
            associationPhotos: (_.size(assocPhotos)) ? assocPhotos : [],
            associationPhotosTree: (_.size(assocPhotosTree)) ? assocPhotosTree : [],
            associationPhotoFolders: (_.size(assocPhotoFolders)) ? assocPhotoFolders : [],
        };

        return _.merge(result, resPhotos, this.state.formChanges);
    }

    public getAssocAddressArray(assoc: any) {
        let result: Array<string> = [];
        if (_.get(assoc, 'location.city', '') || _.get(assoc, 'location.stateCode', '')) {
            if (_.get(assoc, 'location.city', '')) { result.push(_.get(assoc, 'location.city')); }
            if (_.get(assoc, 'location.stateCode', '')) { result.push(_.get(assoc, 'location.stateCode')); }
        }

        return result;
    }

    public getFormChangesCount() {
        if (_.size(this.state.formChanges.specialAssessments) || _.size(this.state.formChanges.specialAssessmentsCustomer)) {
            return (_.size(this.state.formChanges.specialAssessments)) + (_.size(this.state.formChanges.specialAssessmentsCustomer));
        } else if (this.state.formChanges.formChangesReset) {
            return 1;
        }
        return (_.size(this.state.formChanges) - 2);
    }

    public getCurrentOrderChartClone(currentOrderChart: any, formData: any) {
        return _.merge({}, currentOrderChart, _.pick(formData, [
            'begBalance',
            'beginYear',
            'calculateYears',
            'currentAnnualIncrease',
            'currentMRCVal',
            'currentSecondaryAnnualIncrease',
            'currentYears',
            'currentSA',
            'draft',
            'groupComponents',
            'groupComponentsPictureSection',
            'hideComponentEvaluation',
            'hideFooter',
            'hideNumberOfUnits',
            'inflation',
            'interest',
            'minimumAnnualIncrease',
            'minimumMRCVal',
            'minimumSecondaryAnnualIncrease',
            'minimumYears',
            'perFirstYear',
            'recommendedAnnualIncrease',
            'recommendedMRCVal',
            'recommendedSecondaryAnnualIncrease',
            'recommendedYears',
            'sa',
            'showCurrent',
            'showPageNumbers',
            'showMinimum',
            // 'showRecommended',
            'showYearlySummaryCurrent',
            'showYearlySummaryMinimum',
            'versionId']));
    }

    // Renderers
    public renderAssocHeader = (assoc) => {
        return (
            <InventoryDetailFormComponentDetailsAssociation sectionTitle={this.appText('association-details')}>
                <AssociationDetailsCopyAddress association={assoc} />
            </InventoryDetailFormComponentDetailsAssociation>
        );
    }

    public renderSaveChangesBeforePDFModal = () => {
        return (
            <Modal show={this.state.showModalSaveChanges} onHide={() => this.closeModal()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('save-changes-modal.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.appText('save-changes-modal.body')}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={(e) => this.handleSaveButton(e, true)}>{this.appText('save-changes-then-view')}</Button>
                    <Button bsStyle="warning" onClick={(e) => this.handleOverrideButton(e)}>{this.appText('override-save-changes')}</Button>
                    <Button onClick={() => this.closeModal()}>{this.appText('app.common.buttons.cancel', false)}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderModalSelectPicture = (formData: any) => {
        const allImages = _.get(formData, 'associationPhotos', []);
        const selectPictureField = 'coverPagePicture'; // Formatters.getStr(this.state, 'showModalSelectPictureForPictureField');
        const selectedPicturePath = Formatters.getStr(formData, selectPictureField);
        const selectedPictureFilename = _.last(selectedPicturePath.split('/'));
        const selectedPictureObj = _.find(allImages, (o) =>
            Formatters.getStr(o, 'pathDecoded') === selectedPicturePath ||
            Formatters.getStr(o, 'path') === selectedPicturePath
        );
        const selectedPictureFolder =
            Formatters.getStr(this.state, 'showModalSelectPictureFolder') ||
            Formatters.getStr(selectedPictureObj, 'parentFolder');
        let treeBeardDataActive: any;

        // console.log(`reserve-study/index::renderModalSelectPicture`, {
        //     formData,
        //     allImages,
        //     selectPictureField,
        //     selectedPicturePath,
        //     selectedPictureFilename,
        //     selectedPictureObj,
        //     selectedPictureFolder,
        // });

        const getPictureText = (index, name, path) => {
            return `${path}`;
        };

        // react-treebeard functionality
        const getTreeItemFile = (treeItem: any, treeItemKeyName: string = '', selectedPicPath: string = '', parentTreeItemKey: string = '') => {
            // if (!treeItem || treeItemKeyName || !selectedPicPath) { return null; }
            return null;

            /*
            const fileName = _.last(selectedPicPath.split('/'));
            const selectedPictureInFolder = (treeItemKeyName === fileName); // getSelectedPictureInTreeItemPath(treeItemKeyName, fileName, false);

            // console.log(`getTreeItemFile treeItemKeyName ${treeItemKeyName} fileName ${fileName} vs selectedPicPath ${selectedPicPath} result:`);

            if (selectedPictureInFolder) {
                const result = {
                    name: fileName,
                    active: selectedPictureInFolder,
                    children: [],
                };

                return result;
            }

            return null;
            */
        };

        const getTreeItemFolder = (treeItem: any, treeItemKey: string = '', selectedPicPath: string = '', treeItemFullPath: string = '') => {
            const isFolderActive = (selectedPictureFolder === treeItemFullPath) || (selectedPictureFolder === treeItemKey);

            const res = {
                name: treeItemKey,
                toggled: isFolderActive,
                active: isFolderActive,
                fullPath: treeItemFullPath,
                children: _.compact(getTreeItemChildren(treeItem, treeItemKey, selectedPicPath, treeItemFullPath))
            };

            if (isFolderActive) { treeBeardDataActive = res; }

            return res;
        };

        const getTreeItemChildren = (treeItem: any, treeItemName: string = '', selectedPicPath: string = '', parentTreeItemName: string = '') => {
            const treeItemType = _.get(treeItem, `treeItemType`, '');

            /* if (treeItemType === 'file') {
                return getTreeItemFile(treeItem, treeItemName, selectedPicPath);
            } else { */
            const treeItemChildrenKeys = getTreeItemChildrenKeys(treeItem, treeItemName);

            return _.flatten(_.map(treeItemChildrenKeys, (ticKey) => {
                const treeItemChild = _.get(treeItem, ticKey);
                const treeItemChildType = _.get(treeItemChild, `treeItemType`, 'folder');
                const treeItemFullPath = `${parentTreeItemName}/${treeItemName}/${ticKey}`;

                if (treeItemChildType === 'file') {
                    return getTreeItemFile(treeItemChild, ticKey, selectedPicPath, treeItemFullPath);
                } else {
                    return getTreeItemFolder(treeItemChild, ticKey, selectedPicPath, treeItemFullPath);
                }
            }));
            // }
        };

        const getTreeItemChildrenKeys = (treeItem: any, treeItemName: string = '') => {
            let childrenKeys: any = _.stubArray();
            if (treeItem && _.size(treeItem)) {
                childrenKeys = _.keysIn(treeItem);
            }

            return childrenKeys;
        };

        // Treebeard
        const photoRootFolderKey: any = '/Photos';
        const rootFolderKeys: any = getTreeItemChildrenKeys(_.get(formData, 'associationPhotosTree'), 'rootFolderKeys');
        const rootFolderKey: any = _.first(rootFolderKeys);
        const rootFolderTreePath: any = `associationPhotosTree.[${rootFolderKey}]`;
        const rootFolderTreeItem: any = _.get(formData, rootFolderTreePath);
        const isRootFolderActive = selectedPictureFolder === rootFolderKey; // ((selectedPictureFolder === rootFolderKey) || (selectedPictureFolder === '')) ? true : false; // 20190731 selectedPictureFolder === rootFolderKey;

        const treeBeardData = {
            name: rootFolderKey,
            toggled: true,
            active: isRootFolderActive,
            fullPath: `${photoRootFolderKey}/${rootFolderKey}`,
            children: _.compact(getTreeItemChildren(rootFolderTreeItem, rootFolderKey, selectedPicturePath, photoRootFolderKey))
        };

        if (isRootFolderActive) { treeBeardDataActive = treeBeardData; }

        const selectedPictureFolderFullPath = (treeBeardDataActive) ? Formatters.getStr(treeBeardDataActive, 'fullPath') : selectedPictureFolder;

        const treeBeardDecorators = _.merge({}, Treebeard.decorators, {
            Toggle: ({ style }) => {
                return (
                    <div style={style.base}>
                        <div style={style.wrapper} />
                    </div>
                );
            },

            Header: ({ style, node }) => {
                const iconType = (node.active) ? 'folder-open-o' : 'folder-o';
                const iconClass = `fa fa-${iconType}`;
                const iconStyle = { marginRight: '5px' };
                const divStyle = (node.active) ? style.titleActive : style.title;

                return (
                    <div style={style.base}>
                        <div style={divStyle}>
                            <i className={iconClass} style={iconStyle} />
                            {node.name}
                        </div>
                    </div>
                );
            }
        });

        const filteredImages = (selectedPictureFolder) ? _.filter(allImages, ['parentFolder', selectedPictureFolder]) : allImages;

        const galleryImages = filteredImages.map((p, ind) => {
            const path = Formatters.getStr(p, 'path');
            const pathDecoded = Formatters.getStr(p, 'pathDecoded');
            const fileName = (pathDecoded && _.includes(pathDecoded, '/')) ? _.last(pathDecoded.split('/')) : '';

            return {
                id: ind,
                src: ApiEndpoints.getInventoryPictureUrl(path, false),
                thumbnail: ApiEndpoints.getInventoryPictureUrl(path, true, 'w_100,h_75,c_fill,f_auto/'),
                thumbnailFallback: ApiEndpoints.getInventoryPictureUrl(DefaultPictureNotFoundUrl, true, 'w_100,h_75,c_fill,f_auto/'),

                caption: getPictureText(ind, _.get(formData, 'componentCustomName', ''), pathDecoded),
                orientation: 'square',
                title: fileName,
                pathDecoded: Formatters.getStr(p, 'pathDecoded'),
            };
        });

        const { associationId, ...rest } = this.props;

        const inventoryId = 0; // TODO: EXTEND UPLOAD FUNCTIONALITY TO ALLOW COVER PICTURE UPLOADS RATHER THAN INVENTORY UPLOADS
        const uploadSaveUrl = ApiEndpoints.getUpdateAssociationInventoryUploadSaveUrlNew(associationId, inventoryId);
        const uploadRemoveUrl = ApiEndpoints.getUpdateAssociationInventoryUploadRemoveUrl(associationId, inventoryId);

        return (
            <Modal enforceFocus={false} bsSize="large" show={this.state.showModalSelectCoverPicture} onHide={(e) => this.handleHideModalSelectPictureButton(e)}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.select-picture.title')}: {Formatters.getStr(formData, 'component.componentId')} - {Formatters.getStr(formData, 'componentCustomName')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col xs={4}>
                            <div className="modal-select-picture-folder-tree">
                                <Treebeard.Treebeard
                                    style={TreeBeardStyle}
                                    data={treeBeardData}
                                    onToggle={(node, toggled) => { this.handleTreeToggle(node, toggled); }}
                                    decorators={treeBeardDecorators}
                                />
                            </div>
                        </Col>
                        <Col xs={8}>
                            <div className="modal-select-picture-current-photo">
                                {selectedPicturePath ? (
                                    <div>
                                        <div className="association-inventory-detail-picture-label detail-rendermodalselectpicture-picture-label">{selectedPictureFilename}</div>
                                        <img className="img-responsive gallery-source img-rounded" src={ApiEndpoints.getInventoryPictureUrl(selectedPicturePath, true, 'w_400,h_250,c_fill,f_auto/')} />
                                        <div className="text-center">
                                            <a
                                                href="#"
                                                onClick={(e) => { this.handleFormInputChange(_.merge({}, e, { 'target.props.name': selectPictureField, 'value': '' }), null); }}
                                                className="association-inventory-detail-picture-link"
                                            >
                                                {this.appTextCommon('buttons.clear')}
                                            </a>
                                        </div>
                                    </div>
                                ) : undefined}
                            </div>
                        </Col>
                    </Row>

                    <hr className="modal-select-picture-gallery-hr" />
                    <div>
                        <span>{this.appText('modals.select-picture.upload-pictures-to-folder')} </span>
                        <Upload
                            batch={true} // {false}
                            multiple={true}
                            defaultFiles={[]}
                            withCredentials={false}
                            onBeforeUpload={(e) => { this.handleUploadBeforeUpload(e, selectedPictureFolderFullPath); }}
                            onBeforeRemove={(e) => { this.handleUploadBeforeRemove(e, selectedPictureFolderFullPath); }}
                            onAdd={(e) => { this.handleUploadAdd(e, selectedPictureFolderFullPath); }}
                            onRemove={(e) => { this.handleUploadRemove(e, selectedPictureFolderFullPath); }}
                            onProgress={(e) => { this.handleUploadProgress(e, selectedPictureFolderFullPath); }}
                            onStatusChange={(e) => { this.handleUploadStatusChange(e, selectedPictureFolderFullPath); }}
                            files={this.state.modalSelectPictureFiles}
                            saveUrl={uploadSaveUrl}
                            removeUrl={uploadRemoveUrl}
                        />
                    </div>

                    <hr className="modal-select-picture-gallery-hr" />
                    <div className="modal-select-picture-gallery">
                        <div className="modal-select-picture-gallery-title">
                            <span>{this.appText('modals.select-picture.displaying')} </span>
                            <span className="modal-select-picture-gallery-title-bold">{this.appTextPlural('modals.select-picture.picture', _.size(galleryImages), true, true)} </span>
                            {(selectedPictureFolderFullPath) ? (
                                <span>
                                    <span>{this.appText('modals.select-picture.in-folder')} </span>
                                    <span className="modal-select-picture-gallery-title-bold">{selectedPictureFolderFullPath}</span>
                                </span>
                            ) : undefined}
                        </div>
                        <InventoryPhotoGallery
                            images={galleryImages}
                            selectLinkCaption={this.appTextCommon('buttons.select') /* this.appText('links.select') */}
                            clearLinkCaption={this.appTextCommon('buttons.clear') /* this.appText('links.clear') */}
                            onSelectLinkClick={(e, o) => { this.handleFormInputChange(_.merge({}, e, { 'target.props.name': selectPictureField, 'value': o.pathDecoded }), o); }}
                            onClearLinkClick={(e, o) => { this.handleFormInputChange(_.merge({}, e, { 'target.props.name': selectPictureField, 'value': '' }), o); }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="info" onClick={(e) => this.handleHideModalSelectPictureButton(e)}>{this.appTextCommon('buttons.select-picture')}</Button>
                    {/* <Button bsStyle="danger" onClick={() => this.handleHideModalSelectPictureButton(1)}>{this.appTextCommon('buttons.cancel')}</Button> */}
                </Modal.Footer>
            </Modal>
        );
    }

    public renderHeaderButtonToolbar = (orderId: any, allOrders: any) => {
        let buttonProps = {
            bsSize: 'sm'
        };
        const orderedByBidDate = _.orderBy(allOrders, 'bidDate', 'asc');

        const curOrderIndex = _.findIndex(orderedByBidDate, (c) => Number(_.get(c, 'orderId', 0)) === Number(orderId));
        const firstOrderId = _.get(orderedByBidDate, '[0].orderId', orderId);
        const lastOrderId = _.get(orderedByBidDate, `[${_.size(orderedByBidDate) - 1}].orderId`, orderId);
        const prevOrderId = (curOrderIndex !== 0) ? _.get(orderedByBidDate, `[${curOrderIndex - 1}].orderId`, orderId) : firstOrderId;
        const nextOrderId = (curOrderIndex !== _.size(orderedByBidDate) - 1) ? _.get(orderedByBidDate, `[${curOrderIndex + 1}].orderId`, orderId) : lastOrderId;
        const activeLabel = `${curOrderIndex + 1} ${this.appTextCommon('buttons.of')} ${Formatters.plural(this.appText('order'), _.size(orderedByBidDate), true)}`;

        const firstButton = <Button
            bsStyle="info" onClick={this.handleShowArchivedChartData(firstOrderId)}>
            {'Oldest Archived Chart'}
        </Button>;

        const previousButton = <Button
            bsStyle="info" onClick={this.handleShowArchivedChartData(firstOrderId)}>
            {'Previous Archived Chart'}
        </Button>;

        const nextButton = <Button
            bsStyle="info" onClick={this.handleShowArchivedChartData(firstOrderId)}>
            {'Next Archived Chart'}
        </Button>;

        const currentButton = <Button
            bsStyle="info" onClick={this.handleShowArchivedChartData(firstOrderId)}>
            {'Current Chart'}
        </Button>;

        const pagination = <ButtonToolbar>
            {firstButton}
            {previousButton}
            {nextButton}
            {currentButton}
        </ButtonToolbar>;

        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <div>
                            <div className="pagination-container">{pagination}</div>
                        </div>
                    </Row>
                </Well>
            </div>
        );
    }

    public getWorksheets(currentOrderChart: any) {
        let worksheet = currentOrderChart.specialAssessments;
        let worksheetCustomer = currentOrderChart.specialAssessmentsCustomer;
        return { regular: worksheet, customer: worksheetCustomer };
    }

    public render() {
        const {
            associationId,
            association,
            currentOrder,
            currentOrderChart,
            associationPhotos,
            associationPhotoFolders,
            associationPhotosTree,
            orders,
            archivedCharts,
        } = this.props;
        const assoc = this.extendAssociationData(association);

        const pageTitle = this.appTextPageTitleAppendString(_.get(assoc, 'name', ''), 'page-title', true);
        let page = (<div />);
        if (Number(_.get(assoc, 'associationId', -1)) === Number(associationId)) {
            const startRender = new Date().getTime();
            const isHypothetical = false;
            const allowOverrides = true;

            const inventory: Array<any> = this.extendInventoryData(this.props.inventory, [], assoc);

            const formData = this.getFormData(assoc, currentOrder, currentOrderChart, associationPhotos, associationPhotoFolders, associationPhotosTree, orders, archivedCharts);

            let cloneCurrentOrderChart = this.getCurrentOrderChartClone(_.cloneDeep(currentOrderChart), formData);
            let cloneCurrentOrder = _.cloneDeep(currentOrder);

            cloneCurrentOrderChart.years = ReportCommon.CalculateYears; // cloneCurrentOrderChart.calculateYears;

            // currentOrder
            cloneCurrentOrder = _.merge({}, cloneCurrentOrder, _.pick(formData, [
                'coverPagePicture',
                'customDisclosureTitle',
                'customDisclosureText',
                'startDate']));

            const cloneCurrentOrderId = Formatters.getInt(cloneCurrentOrder, 'orderId');

            const inventoryIncluded = _.cloneDeep(_.filter(inventory, e => _.get(e, 'included', false)));

            // console.log(`inventoryIncluded`, {inventoryIncluded});
            const calculationResult = ReportLogic.computeFundingCalculations(cloneCurrentOrderChart, cloneCurrentOrder, inventoryIncluded, ReportCommon.CalculateYears);
            // console.log('calculationResult', calculationResult);

            const calculations = AppUtilities.getArray(calculationResult, 'recordSet');
            const calculationsCorrected = _.take(calculations, ReportCommon.CalculateYears); // take 1 less??

            const invMap = AppUtilities.getArray(calculationResult, 'invMap');
            const percentFunded = ReportLogic.getPercentFunded(calculationsCorrected, isHypothetical, false);

            const yearlySummaryData = ReportCharts.getYearlySummaryGridData((e) => this.appText(e), calculationsCorrected, formData.beginYear, ReportCommon.CalculateYears, isHypothetical);
            const yearSummary = _.find(yearlySummaryData, ['year', formData.beginYear]);

            const startingBalance = _.toNumber(_.get(currentOrder, 'startingBalance', 0));
            const begBalance = _.toNumber(_.get(currentOrderChart, 'begBalance', startingBalance));
            const idealBalance = _.toNumber(_.get(yearSummary, (isHypothetical) ? 'h_ffb' : 'ffb', begBalance));
            const percentageFunded = percentFunded > 0 ? percentFunded / 100 : 0;

            formData.percentFunded = Formatters.float(percentFunded, 2);
            formData.percentageFunded = (percentageFunded > 0) ? Formatters.float(percentageFunded, 4) : 0;
            formData.currentFFB = idealBalance;

            if (formData.numberUnits > 0) {
                formData.perUnitLiability = (formData.currentFFB > 0) ? Formatters.float((formData.currentFFB / formData.numberUnits), 2) : formData.perUnitLiability;

                formData.currentMrcPerUnit = (formData.currentMRCVal > 0) ? Formatters.float((formData.currentMRCVal / formData.numberUnits), 2) : formData.currentMrcPerUnit;
                formData.minimumMrcPerUnit = (formData.minimumMRCVal > 0) ? Formatters.float((formData.minimumMRCVal / formData.numberUnits), 2) : formData.minimumMrcPerUnit;
                formData.recommendedMrcPerUnit = (formData.recommendedMRCVal > 0) ? Formatters.float((formData.recommendedMRCVal / formData.numberUnits), 2) : formData.recommendedMrcPerUnit;

                formData.minimumMrcPerUnitIncrease = (formData.minimumMrcPerUnit > 0) ? Formatters.float((formData.minimumMrcPerUnit - formData.currentMrcPerUnit), 2, 1) : formData.minimumMrcPerUnitIncrease;
                formData.recommendedMrcPerUnitIncrease = (formData.recommendedMrcPerUnit > 0) ? Formatters.float((formData.recommendedMrcPerUnit - formData.currentMrcPerUnit), 2, 1) : formData.recommendedMrcPerUnitIncrease;

                formData.minimumMrcPerUnitIncreasePercent = (formData.currentMRCVal > 0 && formData.minimumMrcPerUnit > 0) ?
                    Formatters.float((formData.currentMrcPerUnit / formData.minimumMrcPerUnit), 2, 1) :
                    formData.minimumMrcPerUnitIncreasePercent;

                formData.recommendedMrcPerUnitIncreasePercent = (formData.currentMRCVal > 0 && formData.recommendedMrcPerUnit > 0) ?
                    Formatters.float((formData.currentMrcPerUnit / formData.recommendedMrcPerUnit), 2, 1) :
                    formData.recommendedMrcPerUnitIncreasePercent;
            }

            if (!_.size(this.originalFormDataCache)) { this.originalFormDataCache = _.cloneDeep(formData); }

            // console.log('page data', { cloneCurrentOrderId, formData, cloneCurrentOrder, cloneCurrentOrderChart });
            // console.log(`reserve-study/index.tsx render`, { formData, cloneCurrentOrderChart, cloneCurrentOrder, calculationsCorrected, yearlySummaryData });

            let specialAssessmentsWorksheetShowing = (this.state.showModalSpecialAssessmentsWorksheet);
            let specialAssessmentsWorksheetCustomerShowing = (this.state.showModalSpecialAssessmentsWorksheetCustomer);

            const assocHeader = this.renderAssocHeader(assoc);

            const saveChangesBeforePDFModal = this.renderSaveChangesBeforePDFModal();

            let hasComponentsWithNegativeRUL = _.find(inventory, (o) => Formatters.getInt(o, 'remainingUsefulLife_sort') < 0);

            let hasCustomExecutiveSummaryText = (Formatters.getStr(formData, 'customDisclosureText') !== ''
                || Formatters.getStr(formData, 'customDisclosureTitle') !== ''
                || Formatters.getStr(formData, 'customText') !== ''
                || Formatters.getStr(formData, 'customTitle') !== ''
                || Formatters.getStr(formData, 'rfOverride') !== ''
                || Formatters.getStr(formData, 'srpOverride') !== ''
                || Formatters.getStr(formData, 'cppOverride') !== '') ? true : false;

            const createCustomButtonGroup = (props) => {
                return (
                    <ButtonGroup bsSize="xs">
                        {props.insertBtn}
                        {props.deleteBtn}
                    </ButtonGroup>
                );
            };

            const tableProps: any = {
                options: { btnGroup: createCustomButtonGroup },
                cellEdit: { mode: 'click' },
                insertRow: true,
                deleteRow: true,
                tableHeaderClass: 'th-edit',
                tableSize: 'sm',
            };

            const idColumnProps: any = {
                hidden: true,
                hiddenOnInsert: true,
                isKey: true,
                dataField: 'id',
                autoValue: true,
            };

            const headerColProps: any = {
                headerAlign: 'center',
                dataAlign: 'center',
            };

            const selectRowProp: any = {
                mode: 'checkbox'
            };

            const onAddRowCustomer = (row: any) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const fdsa = _.cloneDeep(formData.specialAssessments);
                const fdsac = _.cloneDeep(formData.specialAssessmentsCustomer);
                const origFormChanges = _.cloneDeep(this.state.formChanges);

                const merged = _.merge([], fcsa, fdsa);
                let mergedCustomer = _.merge([], fcsac, fdsac);

                mergedCustomer.push(row);

                let newFormChanges = origFormChanges;
                newFormChanges = _.assign(newFormChanges, { specialAssessmentsCustomer: mergedCustomer, specialAssessments: merged });

                this.setState({ formChanges: newFormChanges });
            };

            const afterRowDeleteCustomer = (rows: any[]) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const fdsa = _.cloneDeep(formData.specialAssessments);
                const fdsac = _.cloneDeep(formData.specialAssessmentsCustomer);
                const origFormChanges = this.state.formChanges;
                const merged = _.merge([], fcsa, fdsa);
                const mergedCustomer = _.merge([], fcsac, fdsac);

                const rowsToKeep = _.filter(merged, (mergedRow) => !_.includes(rows, mergedRow.id));
                const rowsToKeepCustomer = _.filter(mergedCustomer, (mergedRow) => !_.includes(rows, mergedRow.id));
                let newFormChanges = origFormChanges;
                newFormChanges = _.assign(newFormChanges, { specialAssessmentsCustomer: rowsToKeepCustomer, specialAssessments: rowsToKeep });
                if (_.includes(rows, '00')) {
                    newFormChanges = _.assign(newFormChanges, { currentSA: 0 });
                }

                this.setState({ formChanges: newFormChanges });
                this.handleSaveButton(undefined);
            };

            const onCellEditCustomer = (row: any, fieldName: any, value: any) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const ofdc = _.cloneDeep(this.originalFormDataCache);
                const fdsa = _.get(ofdc, 'specialAssessments', []);
                const fdsac = _.get(ofdc, 'specialAssessmentsCustomer', []);
                let merged = _.merge([], fdsa, fcsa);
                let mergedCustomer = _.merge([], fdsac, fcsac);

                // let merged = _.merge([], formData.specialAssessmentsCustomer, this.state.formChanges.specialAssessmentsCustomer);

                const rowIdx = _.findIndex(merged, (o: any) => o.id === row.id);

                if (rowIdx < 0) { return value; }
                _.set(merged[rowIdx], fieldName, value);

                this.setState({ formChanges: { specialAssessmentsCustomer: mergedCustomer, specialAssessments: merged, formChangesReset: true } });

                return value;
            };

            const onAddRow = (row: any) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const fdsa = _.cloneDeep(formData.specialAssessments);
                const fdsac = _.cloneDeep(formData.specialAssessmentsCustomer);
                const origFormChanges = _.cloneDeep(this.state.formChanges);

                let merged = _.merge([], fcsa, fdsa);
                const mergedCustomer = _.merge([], fcsac, fdsac);

                merged.push(row);

                let newFormChanges = origFormChanges;
                newFormChanges = _.assign(newFormChanges, { specialAssessmentsCustomer: mergedCustomer, specialAssessments: merged });

                this.setState({ formChanges: newFormChanges });
            };

            const afterRowDelete = (rows: any[]) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const fdsa = _.cloneDeep(formData.specialAssessments);
                const fdsac = _.cloneDeep(formData.specialAssessmentsCustomer);
                const origFormChanges = _.cloneDeep(this.state.formChanges);
                const merged = _.merge([], fcsa, fdsa);
                const mergedCustomer = _.merge([], fcsac, fdsac);

                const rowsToKeep = _.filter(merged, (mergedRow) => !_.includes(rows, mergedRow.id));
                const rowsToKeepCustomer = _.filter(mergedCustomer, (mergedRow) => !_.includes(rows, mergedRow.id));
                let newFormChanges = origFormChanges;
                newFormChanges = _.assign(newFormChanges, { specialAssessmentsCustomer: rowsToKeepCustomer, specialAssessments: rowsToKeep });
                if (_.includes(rows, '00')) {
                    newFormChanges = _.assign(newFormChanges, { sa: 0 });
                }

                this.setState({ formChanges: newFormChanges });
                this.handleSaveButton(undefined);
            };

            const onCellEdit = (row: any, fieldName: any, value: any) => {
                const fcsa = _.cloneDeep(this.state.formChanges.specialAssessments);
                const fcsac = _.cloneDeep(this.state.formChanges.specialAssessmentsCustomer);
                const ofdc = _.cloneDeep(this.originalFormDataCache);
                const fdsa = _.get(ofdc, 'specialAssessments', []);
                const fdsac = _.get(ofdc, 'specialAssessmentsCustomer', []);
                let merged = _.merge([], fdsa, fcsa);
                let mergedCustomer = _.merge([], fdsac, fcsac);

                // let merged = _.merge([], formData.specialAssessments, this.state.formChanges.specialAssessments);

                const rowIdx = _.findIndex(merged, (o: any) => o.id === row.id);

                if (rowIdx < 0) { return value; }
                _.set(merged[rowIdx], fieldName, value);

                this.setState({ formChanges: { specialAssessments: merged, specialAssessmentsCustomer: mergedCustomer, formChangesReset: true } });

                return value;
            };

            const currencyFormatter = (c: any, r: any) => <ReportComponents.Currency value={c} decimals={0} />;
            const dateFormatter = (c: any, r: any) => Formatters.formatDateYearDate(c);

            let tableSpecialAssessments =
                <div>
                    <BootstrapTable {..._.merge(
                        {},
                        tableProps,
                        {
                            options: {
                                insertText: this.appText('modals.special-assessments-worksheet.add-year'), // 'Add Assessment',
                                onCellEdit: (r: any, f: any, v: any) => { onCellEdit(r, f, v); },
                                // onDeleteRow: onDeleteRow,
                                onAddRow: onAddRow,
                                selectRow: selectRowProp,
                                afterDeleteRow: afterRowDelete,
                                // afterInsertRow: afterRowInsert
                                // afterTableComplete: afterTableComplete
                            }
                        })}
                        data={formData.specialAssessments}
                        selectRow={selectRowProp}
                    >
                        <TableHeaderColumn {...idColumnProps}>ID</TableHeaderColumn>
                        <TableHeaderColumn {...headerColProps} dataFormat={dateFormatter} dataField="year">Year</TableHeaderColumn>
                        <TableHeaderColumn {...headerColProps} dataFormat={currencyFormatter} dataField="amount">Amount</TableHeaderColumn>
                        {/* <TableHeaderColumn {...headerColProps} dataField="clientRequested">Purpose (optional)</TableHeaderColumn> */}
                    </BootstrapTable>
                </div>;

            let tableSpecialAssessmentsCustomer =
                <div>
                    <BootstrapTable {..._.merge(
                        {},
                        tableProps,
                        {
                            options: {
                                insertText: this.appText('modals.special-assessments-worksheet.add-year'), // 'Add Assessment',
                                onCellEdit: (r: any, f: any, v: any) => { onCellEditCustomer(r, f, v); },
                                // onDeleteRow: onDeleteRowCustomer,
                                onAddRow: onAddRowCustomer,
                                selectRow: selectRowProp,
                                afterDeleteRow: afterRowDeleteCustomer,
                                // afterInsertRow: afterRowInsert
                                // afterTableComplete: afterTableComplete
                            }
                        })}
                        data={formData.specialAssessmentsCustomer}
                        selectRow={selectRowProp}
                    >
                        <TableHeaderColumn {...idColumnProps}>ID</TableHeaderColumn>
                        <TableHeaderColumn {...headerColProps} dataFormat={dateFormatter} dataField="year">Year</TableHeaderColumn>
                        <TableHeaderColumn {...headerColProps} dataFormat={currencyFormatter} dataField="amount">Amount</TableHeaderColumn>
                        {/* <TableHeaderColumn {...headerColProps} dataField="clientRequested">Purpose (optional)</TableHeaderColumn> */}
                    </BootstrapTable>
                </div>;

            const processOverrides = (order) => {
                const overrides = ['rfOverride', 'cppOverride', 'srpOverride'];
                overrides.forEach(override => {
                    order[override] = Formatters.getStr(formData, override) ? Formatters.getStr(formData, override) : (this.state.overrideUpdates[override] === false) ? '' :
                        order[override] ? order[override] : '';
                });
                return order;
            };
            cloneCurrentOrder = processOverrides(cloneCurrentOrder);

            const ExecutiveSummaryButtonToolbarOverride = ({ name, onClick, bsSize = 'xs', numFormChanges, onClickSaveChanges, ...restButtonToolbar }) => {
                const props = {
                    type: 'button',
                    bsSize: bsSize, // 'sm',
                };

                let saveChangesButtonProps = {
                    bsStyle: 'default',
                    disabled: true,
                    title: this.appTextCommon('buttons.no-changes'),
                };

                // console.log(this.state.formChanges);
                if (name in this.state.formChanges) {
                    saveChangesButtonProps = {
                        bsStyle: 'success',
                        disabled: false,
                        title: `${this.appTextCommon('buttons.save')} ${Formatters.plural(this.appTextCommon('buttons.change'), numFormChanges, false)}`,
                    };
                }

                return (
                    <ButtonToolbar>
                        <Button type="button" bsSize={bsSize} bsStyle="info" onClick={onClick}><i className="glyphicon glyphicon-repeat" /> {this.appText('reset-default-text')}</Button>
                        <Button {...props} {...saveChangesButtonProps} onClick={onClickSaveChanges}><i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}</Button>
                    </ButtonToolbar>
                );
            };

            const ExecutiveSummaryButtonToolbarCommands = ({ appText, numFormChanges, onClickSaveChanges, onClickCloneDefault, onClickUseDefault, bsSize = 'xs', ...restButtonToolbar }) => {
                const props = {
                    type: 'button',
                    bsSize: bsSize, // 'sm',
                };

                let saveChangesButtonProps = {
                    bsStyle: 'default',
                    disabled: true,
                    title: this.appTextCommon('buttons.no-changes'),
                };

                if (numFormChanges) {
                    saveChangesButtonProps = {
                        bsStyle: 'success',
                        disabled: false,
                        title: `${this.appTextCommon('buttons.save')} ${Formatters.plural(this.appTextCommon('buttons.change'), numFormChanges, false)}`,
                    };
                }

                return (
                    <ButtonToolbar>
                        <Button {...props} {...saveChangesButtonProps} onClick={onClickSaveChanges}><i className="glyphicon glyphicon-floppy-disk" /> {saveChangesButtonProps.title}</Button>
                        { /* <Button {...props} bsStyle="warning" onClick={onClickCloneDefault}><i className="glyphicon glyphicon-duplicate" /> {this.appTextCommon('buttons.clone-default')}</Button>
                            <Button {...props} bsStyle="danger" onClick={onClickUseDefault}><i className="glyphicon glyphicon-paste" /> {this.appTextCommon('buttons.use-default')}</Button>
                        */ }
                    </ButtonToolbar>
                );
            };

            const inputPropsExecutiveSummary = _.merge({}, {
                colLabelXs: 12,
                colInputXs: 12,
                handleChange: (n) => {
                    this.handleFormInputChange(n, 0);
                }
            });

            const tabExecutiveSummary = (xsCol = 8, textAreaRows = 4) => (
                <KendoWrappers.KendoHorizontalForm>
                    <div className="reserve-study-form-executive-summary-container">
                        <Row>
                            <Col xs={xsCol}>
                                <ReserveStudyFormSection title={this.appText('currently-programmed-projects')}>
                                    <div className="reserve-study-form-executive-summary-text">
                                        <KendoWrappers.KendoTextareaDebounced
                                            name="cppOverride"
                                            value={ReportComponents.ExecutiveSummaryCurrentyProgrammedProjects(
                                                {
                                                    inventory: invMap,
                                                    yearlySummaryData,
                                                    yearSummary,
                                                    allowOverrides,
                                                    currentOrder: cloneCurrentOrder,
                                                    currentOrderChart: cloneCurrentOrderChart,
                                                    formData,
                                                    sectionPages: [],
                                                }
                                            )}
                                            onChange={(e) => this.handleOnChangeOverride(e)}
                                            rows={5}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <ExecutiveSummaryButtonToolbarOverride
                                        name={'cppOverride'}
                                        onClick={(e) => this.handleResetOverrides(e, 'cppOverride')}
                                        onClickSaveChanges={(e) => this.handleSaveButton(e, false)}
                                        numFormChanges={this.getFormChangesCount()}
                                    />
                                </ReserveStudyFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={xsCol}>
                                <ReserveStudyFormSection title={this.appText('significant-reserve-projects')}>
                                    <div className="reserve-study-form-executive-summary-text">
                                        <KendoWrappers.KendoTextareaDebounced
                                            name="srpOverride"
                                            value={ReportComponents.ExecutiveSummarySignificantProjects(
                                                {
                                                    inventory: invMap,
                                                    allowOverrides,
                                                    currentOrder: cloneCurrentOrder,
                                                    sectionPages: [],
                                                }
                                            )}
                                            onChange={(e) => this.handleOnChangeOverride(e)}
                                            resizable={'false'}
                                            rows={5}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <ExecutiveSummaryButtonToolbarOverride
                                        name={'srpOverride'}
                                        onClick={(e) => this.handleResetOverrides(e, 'srpOverride')}
                                        onClickSaveChanges={(e) => this.handleSaveButton(e, false)}
                                        numFormChanges={this.getFormChangesCount()}
                                    />
                                </ReserveStudyFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={xsCol}>
                                <ReserveStudyFormSection title={this.appText('reserve-funding')}>
                                    <div className="reserve-study-form-executive-summary-text">
                                        <KendoWrappers.KendoTextareaDebounced
                                            name="rfOverride"
                                            value={ReportComponents.ExecutiveSummaryReserveFunding(
                                                {
                                                    begBalance,
                                                    idealBalance,
                                                    percentFunded,
                                                    percentageFunded,
                                                    showMinimum: formData.showMinimum,
                                                    numberUnits: formData.numberUnits,
                                                    allowOverrides,
                                                    currentOrder: cloneCurrentOrder,
                                                    currentOrderChart: cloneCurrentOrderChart,
                                                    sectionPages: [],
                                                }
                                            )}
                                            onChange={(e) => this.handleOnChangeOverride(e)}
                                            resizable={'false'}
                                            rows={5}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <ExecutiveSummaryButtonToolbarOverride
                                        name={'rfOverride'}
                                        onClick={(e) => this.handleResetOverrides(e, 'rfOverride')}
                                        onClickSaveChanges={(e) => this.handleSaveButton(e, false)}
                                        numFormChanges={this.getFormChangesCount()}
                                    />
                                </ReserveStudyFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={xsCol}>
                                <ReserveStudyFormSection title={(formData.customTitle) ? formData.customTitle : '(Custom Title Unset)'}>
                                    <div>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="customTitle"
                                            className="k-textbox reserve-study-executive-summary-custom-title-input"
                                            value={formData.customTitle}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <div>
                                        <KendoWrappers.KendoTextareaDebounced
                                            name="customText"
                                            value={formData.customText}
                                            rows={textAreaRows}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <ExecutiveSummaryButtonToolbarCommands
                                        appText={(e) => this.appText(e)}
                                        numFormChanges={this.getFormChangesCount()}
                                        onClickSaveChanges={(e) => this.handleSaveButton(e, false)}
                                        onClickCloneDefault={(e) => this.handleReserveStudyPdfButton(e)}
                                        onClickUseDefault={(e) => this.handleReserveStudyPdfButton(e)}
                                    />
                                </ReserveStudyFormSection>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={xsCol}>
                                <ReserveStudyFormSection title={(formData.customDisclosureTitle) ? formData.customDisclosureTitle : '(Custom Disclosure Title Unset)'}>
                                    <div>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="customDisclosureTitle"
                                            className="k-textbox reserve-study-executive-summary-custom-title-input"
                                            value={formData.customDisclosureTitle}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <div>
                                        <KendoWrappers.KendoTextareaDebounced
                                            name="customDisclosureText"
                                            value={formData.customDisclosureText}
                                            rows={textAreaRows}
                                            {...inputPropsExecutiveSummary}
                                        />
                                    </div>
                                    <ExecutiveSummaryButtonToolbarCommands
                                        appText={(e) => this.appText(e)}
                                        numFormChanges={this.getFormChangesCount()}
                                        onClickSaveChanges={(e) => this.handleReserveStudyPdfButton(e)}
                                        onClickCloneDefault={(e) => this.handleReserveStudyPdfButton(e)}
                                        onClickUseDefault={(e) => this.handleReserveStudyPdfButton(e)}
                                    />
                                </ReserveStudyFormSection>
                            </Col>
                        </Row>
                    </div>
                </KendoWrappers.KendoHorizontalForm>
            );

            /*
                const extraTabConfigs = [
                    {
                        eventKey: 7,
                        title: this.appText('executive-summary'),
                        className: 'tab-pane-grid tab-pane-executive-summary',
                        tabContent: tabExecutiveSummary(8)
                    },
                ];
            */

            const reserveStudyDetails = (
                <div>
                    {saveChangesBeforePDFModal}
                    {this.renderModalSelectPicture(formData)}
                    {/* this.renderSpecialAssessmentsWorksheetModal(formData) */}
                    <Row>
                        <Col xs={12}>
                            <div>
                                <div>
                                    <RSF.ReserveStudyForm
                                        appText={(m, p: boolean = true, t: string = '') => this.appText(m, p, t)}
                                        handleFormInputChange={(n, v) => this.handleFormInputChange(n, v)}
                                        handleSubmitForm={(e) => this.handleFormSubmit(e)}
                                        handleViewFundingDisclosure={(e) => this.handleViewFundingDisclosureClick(e)}
                                        handleEditOrderButton={(e, o) => this.handleEditOrderButton(e, cloneCurrentOrderId)}
                                        formData={formData}
                                        className="____form-inline"
                                        currentOrder={cloneCurrentOrder}
                                        currentOrderChart={cloneCurrentOrderChart}
                                        assoc={assoc}
                                        specialAssessmentsWorksheetTable={tableSpecialAssessments}
                                        specialAssessmentsWorksheetShowing={specialAssessmentsWorksheetShowing}
                                        specialAssessmentsWorksheetCustomerTable={tableSpecialAssessmentsCustomer}
                                        specialAssessmentsWorksheetCustomerShowing={specialAssessmentsWorksheetCustomerShowing}
                                        numFormChanges={this.getFormChangesCount()}
                                        handleSaveChanges={(e) => this.handleSaveButton(e)}
                                        handleCloseSpecialAssessmentsWorksheetModal={(e) => this.handleCloseSpecialAssessmentsWorksheetModal(e)}
                                        handleShowSpecialAssessmentsWorksheetModal={(e) => this.handleShowSpecialAssessmentsWorksheetModal(e)}
                                        handleCloseSpecialAssessmentsWorksheetCustomerModal={(e) => this.handleCloseSpecialAssessmentsWorksheetCustomerModal(e)}
                                        handleShowSpecialAssessmentsWorksheetCustomerModal={(e) => this.handleShowSpecialAssessmentsWorksheetCustomerModal(e)}
                                        handleViewPdf={(e) => this.handleReserveStudyPdfButton(e)}
                                        handleViewPortal={(e) => this.handleViewPortalButton(e)}
                                        handleViewAssociation={(e) => this.handleViewAssociationButton(e)}
                                        handleViewInventory={(e) => this.handleViewInventoryButton(e)}
                                        hasComponentsWithNegativeRUL={(hasComponentsWithNegativeRUL) ? true : false}
                                        hasCustomExecutiveSummaryText={(hasCustomExecutiveSummaryText) ? true : false}
                                        handleSelectCoverPicture={(e) => this.handleSelectCoverPictureButton(e)}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <ReportCharts.ChartTabs
                                calculations={calculationsCorrected}
                                inventoryMap={invMap}
                                tabsId="chartTabs"
                                appText={(e) => this.appText(e)}
                                isHypothetical={isHypothetical}
                                beginYear={formData.beginYear}
                                yearsCount={ReportCommon.CalculateYears}
                                appTextGridColumnHeader={(e) => this.appTextGridColumnHeader(e)}
                                // extraTabConfigs={extraTabConfigs}
                                formData={formData}
                                assoc={assoc}
                                currentOrder={cloneCurrentOrder}
                                currentOrderChart={cloneCurrentOrderChart}
                                percentFunded={percentFunded}
                                yearlySummaryData={yearlySummaryData}
                                scenarioLabel={' '}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <RSF.ReserveStudyFormSection title={this.appText('executive-summary')} className="reserve-study-form-executive-summary-section">
                                {tabExecutiveSummary(12, 3)}
                            </RSF.ReserveStudyFormSection>
                        </Col>
                    </Row>
                </div>
            );

            page = (
                <WhiteBoxPageSection title="" pageSectionColXl={10}>
                    <Row className="row-reserve-study-header"><Col xs={12} xl={12}>{assocHeader}</Col></Row>
                    {/*(_.size(ordersWithCharts) > 0) ? this.renderHeaderButtonToolbar(currentOrder.orderId, ordersWithCharts) : <div />*/}
                    <Row className="row-reserve-study-body"><Col xs={12}>{reserveStudyDetails}</Col></Row>
                </WhiteBoxPageSection>
            );

            const endRender = new Date().getTime();

            // console.log(`Render time: ${endRender - startRender}ms`);
        }

        const { ...rest } = this.props;
        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                <div className="renderpage-wrapper">
                    {page}
                </div>
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = (assocId) => ApiEndpoints.getReserveStudyUrl(assocId);

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getReserveStudyRequest(
    getApiUrl(_.get(props, 'associationId', 0)),
    ReduxQueries.PropsAccessToken(props)
);

const mapStateToProps = (state, props) => {
    const associationId = _.get(props, 'match.params.associationId', 0);

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(associationId), state, props, {
        association: state.entities.reserveStudyAssociation,
        associationId: associationId,
        currentOrder: state.entities.reserveStudyCurrentOrder,
        currentOrderChart: state.entities.reserveStudyCurrentOrderChart,
        inventory: state.entities.reserveStudyInventory,
        orders: state.entities.reserveStudyOrders,
        archivedCharts: state.entities.reserveStudyArchivedCharts,
        associationPhotos: state.entities.reserveStudyAssociationPhotos,
        associationPhotoFolders: state.entities.reserveStudyAssociationPhotoFolders,
        associationPhotosTree: state.entities.reserveStudyAssociationPhotosTree,
    });
};

const mapDispatchToProps = {
    updateReserveStudyChart: MutateActions.updateReserveStudyChartMutateAsync,
    navigateTo: (path) => push(path),
};

const ReserveStudyContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(ReserveStudy);

export default withRouter(ReserveStudyContainer);



// WEBPACK FOOTER //
// ./src/reserve-study/index.tsx